import { useRef } from 'react';
import { Link } from '@tanstack/react-router';

import { pluralize } from '@libs/i18n';

import { useClubColors } from '@features/club/hooks/useClubColors';
import { ClubLogo } from '@features/club/ui/ClubLogo';
import { PromotedClubBackground } from '@features/club/ui/PromotedClubs/PromotedClubBackground';
import styles from '@features/club/ui/PromotedClubs/PromotedClubs.module.css';
import { components } from '@features/shared/api/public';

const MEMBERS_PLURAL = {
  one: '{number}\u000Aучастник',
  few: '{number}\u000Aучастника',
  many: '{number}\u000Aучастников',
  zero: '{number}\u000Aучастников',
};

const TOURNAMENTS_PLURAL = {
  one: '{number}\u000Aтурнир',
  few: '{number}\u000Aтурнира',
  many: '{number}\u000Aтурниров',
  zero: '{number}\u000Aтурниров',
};

export function PromotedClub({
  club,
  isMember,
}: {
  club: components['schemas']['ClubPublicDto'];
  isMember: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useClubColors(club.themeColor, ref);

  return (
    <Link to="/club/$clubId" params={{ clubId: club.clubId }} className={styles.promotedClub}>
      <div className={styles.header}>
        <div className={styles.title}>{club.title}</div>
        <ClubLogo className={styles.logo} logoUrl={club.logoUrl} />
      </div>

      <div className={styles.info} ref={ref}>
        <span>{pluralize(MEMBERS_PLURAL, club.membersCount)}</span>
        <span>{pluralize(TOURNAMENTS_PLURAL, club.finishedTournamentsCount)}</span>
      </div>

      <div className={styles.joinButton}>{isMember ? 'Перейти ›' : 'Вступить ›'}</div>

      <PromotedClubBackground color={club.themeColor || '#d7a03d'} />
    </Link>
  );
}
